function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20ad9b;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M24.75,9V26.25a6,6,0,0,1-12,0V7.5a3.75,3.75,0,0,1,7.5,0V23.25a1.5,1.5,0,0,1-3,0V9H15V23.25a3.75,3.75,0,0,0,7.5,0V7.5a6,6,0,0,0-12,0V26.25a8.25,8.25,0,0,0,16.5,0V9Z",
  transform: "translate(-10.5 -1.5)"
});

const SvgIconAttach = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.5,
    height: 33,
    viewBox: "0 0 16.5 33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAttach, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Attach.bf31b8e3.svg";
export { ForwardRef as ReactComponent };